<template>
<svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 70.402 70.402">
  <g id="Group_97" data-name="Group 97" transform="translate(-1449.588 -1130.68)">
    <circle id="Ellipse_77" data-name="Ellipse 77" cx="35.201" cy="35.201" r="35.201" transform="translate(1449.588 1130.68)" fill="#fff"/>
    <g id="Group_96" data-name="Group 96">
      <path id="Path_220" data-name="Path 220" d="M1501.357,1183.6h-2.82v-33.843h1.41v-4.231h-31.023v4.231h1.41V1183.6h-2.115a.705.705,0,0,0,0,1.41h17.626V1169.5h9.871v15.512h5.641a.705.705,0,0,0,0-1.41Zm-18.332-14.1v5.641h-9.871V1169.5Zm0-8.46v5.64h-9.871v-5.64Zm0-8.461v5.64h-9.871v-5.64Zm12.691,8.461v5.64h-9.871v-5.64Zm0-8.461v5.64h-9.871v-5.64Z" fill="#1a1818"/>
    </g>
  </g>
</svg>
</template>

<script>
export default {
  'name': 'A_04',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/attributes/A_04.vue